import { useMutation } from "@apollo/client/react";
import {
  CreateMultipleChoiceInKurssloeyfe,
  CreateMultipleChoiceInKurssloeyfeInput,
  CreateMultipleChoiceInKurssloeyfeVariables,
  MultipleChoiceType,
} from "__generated__/types";
import { MultipleChoiceCreateForm } from "domain/admin/multiple-choice/MultipleChoiceCreateForm";
import gql from "graphql-tag";
import React from "react";

const MUTATION = gql`
  mutation CreateMultipleChoiceInKurssloeyfe(
    $input: CreateMultipleChoiceInKurssloeyfeInput!
  ) {
    createMultipleChoiceInKurssloeyfe(input: $input) {
      kurssloeyfeMultipleChoice {
        id
      }
    }
  }
`;

interface Props {
  kurssloeyfeId: string;
  type: MultipleChoiceType;
  cancel(): void;
  complete(): void;
}

export const KurssloeyfeMultipleChoiceCreateForm: React.FC<
  React.PropsWithChildren<Props>
> = ({ kurssloeyfeId, type, cancel, complete }) => {
  const [mutate, { loading, error }] = useMutation<
    CreateMultipleChoiceInKurssloeyfe,
    CreateMultipleChoiceInKurssloeyfeVariables
  >(MUTATION);

  const onSubmit = async (
    data: CreateMultipleChoiceInKurssloeyfeInput["multipleChoice"],
  ) => {
    const result = await mutate({
      variables: {
        input: {
          kurssloeyfeId,
          multipleChoice: {
            title: data.title,
            type: type,
          },
        },
      },
    });

    return !!result.data;
  };

  return (
    <MultipleChoiceCreateForm
      mutate={onSubmit}
      loading={loading}
      error={error}
      cancel={cancel}
      complete={complete}
    />
  );
};
